var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-nav-bar',{attrs:{"title":"找不到页面","left-text":"返回","right-text":"","left-arrow":""},on:{"click-left":_vm.onBack}}),_c('van-empty',{attrs:{"description":"找不到页面"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }